import moment from 'moment';
import React from 'react';

import {
  getFormattedDate,
  isWithin48Hours,
  APPROVED_MESSAGE,
  AWAITING_MESSAGE,
  NOT_SUBMITTED_MESSAGE,
  ZERO_HOURS_MESSAGE
} from '../utils';

export function payPeriodStatusMessage(payPeriod, modal = false) {
  const {
    approvedAt,
    editedAt,
    submittedAt,
    standardHours,
    nonStandardHours,
    doubleTimeHours,
    additionalBilling,
    disputedAt,
    disputeExplanation,
    hasPendingAdjustment,
    pendingAdjustmentCreatedAt,
    timesheetStatusWithInvoiceDate,
    status,
  } = payPeriod.attributes;

  const correctionPrefix = hasPendingAdjustment ? "Correction: " : "";

  if (disputedAt && modal) {
    return (
      <>
        <div style={{ marginBottom: 8 }}>
          <span style={{ color: '#FF6D6D', fontWeight: 'bold' }}>{correctionPrefix}Disputed By Approving Party</span> - Please resubmit hours to remove the disputed status.
        </div>
        <div style={{ marginBottom: 8 }}>
          <span style={{ fontWeight: 'bold' }}>Dispute Explanation:</span> {disputeExplanation}
        </div>
      </>
    );
  }

  if (modal && timesheetStatusWithInvoiceDate) {
    return <span>{timesheetStatusWithInvoiceDate}</span>;
  }

  if (hasPendingAdjustment && pendingAdjustmentCreatedAt) {
    const adjustmentDate = moment(pendingAdjustmentCreatedAt).format('MMMM D, YYYY');
    return `${correctionPrefix}Submitted ${adjustmentDate}`;
  }

  if (status) {
    return `${correctionPrefix}${status}`;
  }

  const day = (moment().isoWeekday() < 3) ? 3 : 10;
  const zeroHoursDate = getFormattedDate(moment().isoWeekday(day)
    .hours(23)
    .minutes(30)
    .utcOffset('America/New_York'));

  const nextWednesday = moment().clone().startOf('week').add(3, 'days')
    .hours(23)
    .minutes(30)
    .utcOffset('America/New_York');

  let formattedUpcomingWednesday = getFormattedDate(nextWednesday);

  const isSubmittedOrEditedWithin48Hours =
    isWithin48Hours(submittedAt, formattedUpcomingWednesday) ||
    isWithin48Hours(editedAt, formattedUpcomingWednesday);

  if (isSubmittedOrEditedWithin48Hours) {
    formattedUpcomingWednesday = getFormattedDate(nextWednesday.clone().add(7, 'days'));
  }

  if (approvedAt) {
    return `${correctionPrefix}${APPROVED_MESSAGE}`;
  }

  if (submittedAt) {
    if (!standardHours && !nonStandardHours && !doubleTimeHours && !additionalBilling) {
      return modal ? `${correctionPrefix}Submitted - can be edited until ${zeroHoursDate}` : `${correctionPrefix}${ZERO_HOURS_MESSAGE}`;
    }

    return modal ? `${correctionPrefix}Submitted - can be edited until ${formattedUpcomingWednesday} or approved by employer` : `${correctionPrefix}${AWAITING_MESSAGE}`;
  }

  return NOT_SUBMITTED_MESSAGE;
}
